import React, { forwardRef } from "react";

export const DashboardCard = forwardRef(({ title, headerRight, children, className = "" }, ref) => {
  return (
    <div ref={ref} className={`dashboard-card ${className}`}>
      {(title || headerRight) && (
        <div className="dashboard-card__header">
          {title && <h3 className="dashboard-card__title">{title}</h3>}
          {headerRight && <div className="dashboard-card__actions">{headerRight}</div>}
        </div>
      )}
      <div className="dashboard-card__body">
        {children}
      </div>
    </div>
  );
});
